import { render, staticRenderFns } from "./YearRangePicker.vue?vue&type=template&id=2c44845a&scoped=true"
import script from "./YearRangePicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./YearRangePicker.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c44845a",
  null
  
)

export default component.exports